import type { GridTableColumn, GridTableContentSection } from 'components/GridTable/types'
import { SectionTitleBar } from 'components/SectionTitleBar/SectionTitleBar'
import { useEffect, useState } from 'react'
import { colors } from 'settings/colors'
import { ItemRow } from './ItemRow/ItemRow'

export const Section = ({
  columns,
  containerWidth,
  section,
  widthForLabelColumn,
  widthForValueColumns,
}: {
  columns: GridTableColumn[]
  containerWidth: number
  section: GridTableContentSection
  widthForLabelColumn: number
  widthForValueColumns: number
}) => {
  const [collapsed, setCollapsed] = useState(!!section.defaultCollapsed)

  useEffect(() => {
    if ('defaultCollapsed' in section) {
      setCollapsed(!!section.defaultCollapsed)
    }
  }, [section.defaultCollapsed])

  return (
    <>
      <SectionTitleBar
        containerWidth={containerWidth}
        collapsed={collapsed}
        onCollapse={() => setCollapsed(!collapsed)}
        sticky
        title={section.title}
        titleCss={section.titleCss}
        wrapperCss={section.titleBarWrapperCss}
        titleToggle={section.titleToggle}
        titleLink={section.titleLink}
        fieldAssetPicker={section.fieldAssetPicker}
      ></SectionTitleBar>
      <div
        css={{
          // a 0fr to 1fr row animates to the content's own height, so the content never needs a height in pixels
          display: 'grid',
          gridTemplateRows: collapsed ? '0fr' : '1fr',
          opacity: collapsed ? 0 : 1,
          transition: '200ms ease all',
          boxSizing: 'border-box',
          border: `0.5px solid ${colors.grey200}`,
          borderCollapse: 'collapse',
        }}
      >
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflow: collapsed ? 'hidden' : 'unset',
          }}
        >
          {!!section.fullWidthItems?.length &&
            section.fullWidthItems.map((fwi, i) => {
              return (
                <div
                  key={i}
                  css={{
                    // NOTE: keep roughly in sync with StackedChart if desired
                    display: 'flex',
                    minHeight: fwi.height,
                    transition: 'height 200ms, opacity 200ms',
                    padding: 20,
                    position: 'sticky',
                    left: 0,
                    fontSize: 20,
                    fontWeight: 300,
                    width: containerWidth,
                    maxWidth: containerWidth,
                    boxSizing: 'border-box',
                    border: `0.5px solid ${colors.grey200}`,
                    borderCollapse: 'collapse',
                    overflow: 'hidden',
                    ...fwi.contentCss,
                  }}
                >
                  {fwi.content}
                </div>
              )
            })}
          {!!section.items?.length &&
            section?.items.map((item) => (
              <ItemRow
                columns={columns}
                height={item.height}
                key={item.id}
                label={item.label}
                labelCellCSS={item.labelCellCSS}
                render={item.render}
                values={item.values}
                widthForLabelColumn={widthForLabelColumn}
                widthForValueColumns={widthForValueColumns}
              />
            ))}

          {!!section.belowFullWidthItems?.length &&
            section.belowFullWidthItems.map((bfwi, i) => {
              return (
                <div
                  key={i}
                  css={{
                    // NOTE: keep roughly in sync with StackedChart if desired
                    display: 'flex',
                    transition: 'height 200ms, opacity 200ms',
                    padding: 20,
                    position: 'sticky',
                    left: 0,
                    fontSize: 20,
                    fontWeight: 300,
                    width: containerWidth,
                    maxWidth: containerWidth,
                    boxSizing: 'border-box',
                    border: `0.5px solid ${colors.grey200}`,
                    borderCollapse: 'collapse',
                    overflow: 'hidden',
                  }}
                >
                  {bfwi.content}
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}
